import React, { useEffect, useState } from 'react'
import { Get_Api } from '../ApiUrls';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

function PrivacyPolicy() {
    const [privacyPolicy, setPrivacyPolicy] = useState("");


    const fetchPrivacyPolicy = async () => {
        try {
            const response = await Get_Api('api/admin/GetPrivacyPolicy');;
            if (response.data) {
                setPrivacyPolicy(response?.data?.PrivacyPolicy);
            }
        } catch (error) {
            console.error("Error fetching Privacy Policy", error);
        }
    };

    useEffect(() => {
        fetchPrivacyPolicy();
    }, []);

    return (
        <>
            <Navbar />
            <div className="ContactUs-header">
                <h1>Privacy Policy</h1>
                <p>
                    Home / <span className="active">Privacy Policy</span>
                </p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>
                <div
                    dangerouslySetInnerHTML={{ __html: privacyPolicy }}
                    style={{
                        color: 'black',
                        fontSize: '15px',
                        lineHeight: '2.0',
                        maxWidth: '800px',
                        width: '100%',
                    }}
                >
                </div>
            </div>
            <Footer />
        </>
    )
}

export default PrivacyPolicy